import { Link, Outlet, useLocation } from 'react-router-dom';
import { Button } from '@/components/Button';
import { useTheme } from '@/hooks/useTheme';

function ThemeButton() {
  const { mode, cycle } = useTheme();
  const label = mode === 'light' ? '浅色' : mode === 'dark' ? '深色' : '跟随系统';
  return (
    <Button
      size="md"
      variant="ghost"
      onClick={cycle}
      aria-label={`主题：${label}（点击切换）`}
      title={`当前：${label}（点击切换）`}
    >
      <span aria-hidden>{mode === 'light' ? '☀' : mode === 'dark' ? '☾' : '◐'}</span>
      <span className="hidden sm:inline">{label}</span>
    </Button>
  );
}

/** 应用外壳：顶栏 + 内容 + 页脚。所有数据都在本机，因此顶栏不涉及账号与同步。 */
export function AppShell() {
  const location = useLocation();
  const isReport = location.pathname.endsWith('/report');

  return (
    <div className="flex min-h-dvh flex-col bg-surface-0">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-50 focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-sm focus:text-accent-fg"
      >
        跳到主要内容
      </a>

      <header className="no-print sticky top-0 z-30 border-b border-line bg-surface-0/90 backdrop-blur">
        <div className="container-page flex h-14 items-center justify-between gap-3">
          <Link to="/" className="flex min-w-0 items-center gap-2.5">
            <svg viewBox="0 0 32 32" aria-hidden className="size-7 shrink-0 rounded-md">
              <rect width="32" height="32" rx="7" fill="var(--accent)" />
              <g fill="var(--accent-fg)">
                <circle cx="9" cy="9" r="3.2" />
                <circle cx="23" cy="9" r="3.2" />
                <circle cx="9" cy="23" r="3.2" />
                <circle cx="23" cy="23" r="3.2" />
              </g>
              <rect x="12.6" y="12.6" width="6.8" height="6.8" rx="1.6" fill="var(--accent-fg)" />
            </svg>
            <span className="min-w-0">
              <span className="block truncate text-sm font-semibold text-fg">Havorix 搭建评估</span>
              <span className="block truncate text-[10px] text-fg-subtle">4 轴无人机可行性快速评估</span>
            </span>
          </Link>

          <div className="flex shrink-0 items-center gap-1.5">
            <span className="hidden text-[11px] text-fg-subtle md:inline">数据只保存在本机浏览器</span>
            <ThemeButton />
          </div>
        </div>
      </header>

      <main id="main" className="flex-1 py-4">
        <div className="container-page">
          <Outlet />
        </div>
      </main>

      {isReport ? null : (
        <footer className="no-print border-t border-line py-4">
          <div className="container-page text-[11px] leading-relaxed text-fg-subtle">
            所有数据仅保存在本机浏览器，不会上传。结果为搭建前的快速可行性参考，经验估算误差约 ±20%，请以实测为准。
          </div>
        </footer>
      )}
    </div>
  );
}
